module.exports = __webpack_public_path__ + "img/banner-3.851db18.webp";